import { useRef, useState } from "react";
import { IconButton, Popover, List, ListSubheader, ListItemButton, ListItemText, Link, Divider } from "@mui/material";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import { IMoreOptions } from "src/types/molecules";
import { Link as ReactRouterLink } from "react-router-dom";
const MoreOptions = ({
  options = []
}: IMoreOptions) => {
  const optionsBtn = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const classes = {
    root: {
      position: "absolute",
      top: 12,
      right: 10
    },
    paper: {
      borderRadius: 1
    }
  };
  return <>
      <IconButton aria-label="Más opciones" sx={classes.root} ref={optionsBtn} onClick={() => setOpen(true)}>
        <ThreeDotsVertical size="1.2rem" />
      </IconButton>
      <Popover open={open} onClose={() => setOpen(false)} anchorEl={optionsBtn.current} anchorOrigin={{
      vertical: "bottom",
      horizontal: "center"
    }} slotProps={{
      paper: {
        sx: classes.paper
      }
    }}>
        <List dense subheader={<>
              <ListSubheader>Más opciones</ListSubheader>
              <Divider />
            </>}>
          {options.filter(op => op.show || op.show === undefined).map((op, idx) => <ListItemButton onClick={() => {
          // SUGGESTION-C (verify-report obs #61 rev 2): the Popover
          // only ever closed via onClose (outside click / Escape),
          // so an async entry like Imprimir stayed open and
          // clickable for the full ~1s fetch-plus-render, letting a
          // second click fire a second print (two tabs). Close on
          // every selection, matching the standard menu-item pattern
          // — checked: RemisionDetail.test.tsx is the only suite
          // that exercises this dropdown, and only asserts on
          // Imprimir's own behavior, never on the Popover staying
          // open after Eliminar/Editar nombre/Agregar productos.
          op.onClick?.();
          setOpen(false);
        }} key={`moreopt-${idx}`}>
                {op.path ? <Link underline="none" color={"unset"} component={ReactRouterLink} to={op.path} state={op.state}>
                    <ListItemText primary={op.primary} />
                  </Link> : <ListItemText primary={op.primary} />}
              </ListItemButton>)}
        </List>
      </Popover>
    </>;
};
export default MoreOptions;